<div class="container-fluid content-wrapper">
  <h4 class="page-heading my-5">{{title | googleTranslate | async}}</h4>

  <div class="row">
    <div class="col-12" [innerHTML]="content"></div>
  </div>
</div>
